import React from 'react';
import FileView from '@plone/volto/components/theme/View/FileView';
import { flattenToAppURL } from '@plone/volto/helpers';
import DocumentView from './DocumentView';

/**
 * `File` view override (BL-0032).
 *
 * `File` is a generic Plone/Volto type used all over the three archives, not
 * just for the reviewed change-charts/admin-change memos this ticket adds
 * full-text rendering for. The backend behavior that carries
 * `full_text_sections` is applied to the type FTI (Plone has no per-folder
 * behavior scoping), so every File technically has the field -- but the
 * reconciler (`backend/src/dox/policyportal/core/fulltext.py`,
 * `file_container_eligible`) only ever writes it for Files inside `files`/
 * `related-items` containers. `omb-submissions` and every other File
 * container are deliberately untouched pending a separate content review, so
 * their pages must render exactly as before: this mirrors that same
 * container check on the frontend, rather than switching every File site-wide
 * to the document layout.
 *
 * Path shape note: each site is its own seamless-mode Volto instance, so
 * `content['@id']` (and `flattenToAppURL` of it) has NO site segment --
 * unlike the backend's `file_container_eligible`, which reads a Solr `path`
 * of the form `<site>/<container>/...`, the container here is the FIRST
 * path segment, not the second.
 */
const FILE_ELIGIBLE_CONTAINERS = ['files', 'related-items'];

function isEligibleFilePath(id) {
  const path = flattenToAppURL(id || '').replace(/^\//, '');
  const parts = path.split('/');
  return parts.length >= 2 && FILE_ELIGIBLE_CONTAINERS.includes(parts[0]);
}

const FileDetailView = (props) =>
  isEligibleFilePath(props.content?.['@id']) ? (
    <DocumentView {...props} />
  ) : (
    <FileView {...props} />
  );

export default FileDetailView;
